import React from 'react';

export interface CheckinProgressBarProps {
  percent: number;
  currentIndex: number;
  total: number;
}

const CheckinProgressBar: React.FC<CheckinProgressBarProps> = ({
  percent,
  currentIndex,
  total,
}) => {
  const safePercent = Math.max(0, Math.min(100, Math.round(percent)));

  return (
    <div className="w-full max-w-[1200px] flex flex-col gap-2 my-6">
      <div className="flex justify-between text-sm text-[#5D6A85]">
        <span>
          Step {currentIndex} of {total}
        </span>
        <span>{safePercent}% complete</span>
      </div>
      <div className="h-2 bg-[#DCE1E8] rounded-full overflow-hidden">
        <div
          className="h-full bg-[#01545D] transition-all duration-300 ease-out"
          style={{ width: `${safePercent}%` }}
          role="progressbar"
          aria-valuenow={safePercent}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Step ${currentIndex} of ${total}, ${safePercent}% complete`}
        />
      </div>
    </div>
  );
};

export default CheckinProgressBar;
